// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"0affffe5","148":"7418ed9a","306":"1854c184","404":"0eac6e1e","416":"cb52eb6c","553":"ca3dd5d6","666":"0cd939d2","717":"50038876","804":"d54a9c38","808":"aff1ea7d","982":"24adccc3"}[chunkId] + ".chunk.js";
};